import { PostSatisfaction, SatisfactionLabelDatahub } from '../communityModalSurvey.constants'
import { ExperienceOptionsProps } from '../createCommunitySurvey/steps/communityCreationExperience/communityCreationExperience.types'

export enum Step {
  SecondPostExperience = 'SecondPostExperience',
  SecondPostMostLiked = 'SecondPostMostLiked',
  SecondPostImprovement = 'SecondPostImprovement',
  Success = 'Finish'
}

export const PROGRESS_BAR_VALUE_SECOND_POST_EXPERIENCE_STEP = 0

export const PROGRESS_BAR_VALUE_SECOND_POST_MOST_LIKED_STEP = 33.33

export const PROGRESS_BAR_VALUE_SECOND_POST_IMPROVEMENT_FROM_BEGIN_STEP = 50

export const PROGRESS_BAR_VALUE_SECOND_POST_IMPROVEMENT_FROM_MOST_LIKED_STEP = 66.66

export const SECOND_POST_EXPERIENCE_OPTIONS: ExperienceOptionsProps[] = [
  {
    value: PostSatisfaction.VERY_SATISFIED,
    label: 'community_survey.second_post.experience.very_satisfied',
    step_to_go: Step.SecondPostMostLiked,
    label_value_datahub: SatisfactionLabelDatahub.VerySatisfied
  },
  {
    value: PostSatisfaction.SATISFIED,
    label: 'community_survey.second_post.experience.satisfied',
    step_to_go: Step.SecondPostMostLiked,
    label_value_datahub: SatisfactionLabelDatahub.Satisfied
  },
  {
    value: PostSatisfaction.MEDIUM,
    label: 'community_survey.second_post.experience.medium',
    step_to_go: Step.SecondPostImprovement,
    label_value_datahub: SatisfactionLabelDatahub.Medium
  },
  {
    value: PostSatisfaction.UNSATISFIED,
    label: 'community_survey.second_post.experience.unsatisfied',
    step_to_go: Step.SecondPostImprovement,
    label_value_datahub: SatisfactionLabelDatahub.Unsatisfied
  },
  {
    value: PostSatisfaction.VERY_UNSATISFIED,
    label: 'community_survey.second_post.experience.very_unsatified',
    step_to_go: Step.SecondPostImprovement,
    label_value_datahub: SatisfactionLabelDatahub.VeryUnsatisfied
  }
]

export enum SecondPostSurveyQuestionDatahubLabel {
  Question1 = 'Como você se sente em relação a ferramenta de publicação na comunidade?',
  Question2 = 'O que mais você gostou na ferramenta de publicação da Comunidade?',
  Question3 = 'Tem algo que sentiu falta ou acha que poderíamos melhorar na nossa ferramenta de publicação?'
}
